import { render } from "./Promo-texts.vue?vue&type=template&id=b7d00614&scoped=true"
import script from "./Promo-texts.vue?vue&type=script&lang=js"
export * from "./Promo-texts.vue?vue&type=script&lang=js"

import "./Promo-texts.vue?vue&type=style&index=0&id=b7d00614&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b7d00614"]])

export default __exports__